import { render, staticRenderFns } from "./Desempenho.vue?vue&type=template&id=507b9a2a&"
import script from "./Desempenho.vue?vue&type=script&lang=js&"
export * from "./Desempenho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports